// Cliente del servicio de sharing (envío de documentos al paciente vía lore).
// La API key de lore vive en el backend — desde acá solo viaja el JWT de Auth0.

export const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'application/dicom']
export const MAX_FILE_BYTES = 25 * 1024 * 1024

export const sharingEnabled = () => !!process.env.REACT_APP_SHARING_API_URL

const base = () => (process.env.REACT_APP_SHARING_API_URL || '').replace(/\/$/, '')

// El browser suele reportar DICOM como octet-stream — validar por extensión también
export const isAllowedFile = file =>
  ALLOWED_TYPES.includes(file.type) || /\.dcm$/i.test(file.name)

const parse = async res => {
  const data = await res.json().catch(() => null)
  if (res.ok) {
    // Bug real (auditoría 2026-08-16): con res.ok=true y body vacío/inválido,
    // `data` queda `null` y esta función lo devolvía tal cual sin throw. El
    // caller (SendToPatientModal.js submit/retry) hace `share.status` sobre
    // ese `null` y explota con un TypeError crudo ("Cannot read properties
    // of null") que termina mostrándose como error.message — un mensaje
    // críptico sin indicar si el archivo se envió o no.
    if (data == null) throw new Error('Respuesta vacía del servicio')
    return data
  }
  const error = new Error(data?.error?.message || `Error ${res.status}`)
  error.code = data?.error?.code
  error.status = res.status
  throw error
}

// teamID/eventID/shareID viajan sin el prefijo de tipo ("teams/", "events/", "shares/")
const clean = id => (id || '').split('/').pop()

export const listShares = async ({ token, teamID, eventID }) =>
  parse(await fetch(`${base()}/teams/${clean(teamID)}/events/${clean(eventID)}/shares`, {
    headers: { Authorization: `Bearer ${token}` },
  }))

// V2 (card "Envío de archivos a pacientes de Crontu"): historial de
// archivos enviados a UN paciente, cruzando todos sus turnos.
export const listSharesByConsumer = async ({ token, teamID, consumerID }) =>
  parse(await fetch(`${base()}/teams/${clean(teamID)}/consumers/${clean(consumerID)}/shares`, {
    headers: { Authorization: `Bearer ${token}` },
  }))

// `titles`: opcional, un valor por archivo en el MISMO orden que `files`
// (api/services/sharing/src/router.js#sanitizeTitle) — un título vacío/
// faltante cae al filename saneado del lado del backend.
export const createShare = async ({ token, teamID, eventID, files, titles, message }) => {
  const body = new FormData()
  files.forEach(file => body.append('files', file, file.name))
  files.forEach((_, index) => body.append('titles', titles?.[index] || ''))
  if (message) body.append('message', message)
  return parse(await fetch(`${base()}/teams/${clean(teamID)}/events/${clean(eventID)}/shares`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body,
  }))
}

export const retryShare = async ({ token, teamID, shareID }) =>
  parse(await fetch(`${base()}/teams/${clean(teamID)}/shares/${clean(shareID)}/retry`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  }))
